import { render } from "./Main.vue?vue&type=template&id=e3f95572"
const script = {}
script.render = render

export default script